module.exports = __webpack_public_path__ + "static/media/scoop.3b22bff8.mp3";